import script from "./no-menu.vue?vue&type=script&setup=true&lang=js"
export * from "./no-menu.vue?vue&type=script&setup=true&lang=js"

import "./no-menu.vue?vue&type=style&index=0&id=f33313f4&scoped=true&lang=css"

import exportComponent from "D:\\vsts-agent\\_work\\68\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f33313f4"]])

export default __exports__